import React, { useEffect, useMemo, useState } from "react";
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";


const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

const Segments = ({
    segmentsGroup,
    increment,
    decrement,
    amount,
    formatJsonToAddShoppingCart,
    selectedGroup,
    business_name,
    note,
    setNote,
    priceBase,
    quoteData,
    setQuoteData,
    quoteMode,
    hasTableSession,
    deliveryType,
    setDeliveryType,
}) => {
    const [selectionState, setSelectionState] = useState({});
    const [prtsSegOpen, setPrtsSegOpen] = useState(false);
    const [prtsSegStep, setPrtsSegStep] = useState(0);

    // Inicializa selección por defecto (igual que tu lógica)
    useEffect(() => {
        const initial = {};
        segmentsGroup?.forEach((segment) => {
            const defaults = segment.default_items?.map((d) => d.item_id) ?? [];
            if (segment.type === "UNIQ") {
                const first = segment.items?.[0]?.item_id;
                initial[segment.segment_id] = defaults.length ? defaults[0] : first ?? null;
            } else {
                initial[segment.segment_id] = defaults.length ? defaults : [];
            }
        });
        setSelectionState(initial);
    }, [segmentsGroup]);

    const handleChange = (segment, item) => {
        setSelectionState((prev) => {
            const next = { ...prev };
            if (segment.type === "UNIQ") {
                next[segment.segment_id] = item.item_id;
            } else {
                const current = new Set(next[segment.segment_id] ?? []);
                if (current.has(item.item_id)) current.delete(item.item_id);
                else current.add(item.item_id);
                next[segment.segment_id] = Array.from(current);
            }
            return next;
        });
    };

    // Total (igual que tu lógica)
    const totalPrice = useMemo(() => {
        let extra = 0;
        segmentsGroup.forEach((seg) => {
            if (seg.type === "UNIQ") {
                const selId = selectionState[seg.segment_id];
                const found = seg.items.find((i) => i.item_id === selId);
                if (found) extra += Number(found.price || 0);
            } else {
                const selIds = selectionState[seg.segment_id] ?? [];
                selIds.forEach((id) => {
                    const found = seg.items.find((i) => i.item_id === id);
                    if (found) extra += Number(found.price || 0);
                });
            }
        });
        const unit = Number(priceBase || 0) + extra;
        return unit * amount;
    }, [amount, selectionState, segmentsGroup, priceBase]);

    // ===== NUEVO: Step-by-step =====
    const prtsSegSteps = useMemo(() => {
        // 1 paso por cada segment + Notas + Resumen
        const segSteps = (segmentsGroup || []).map((s) => ({
            type: "segment",
            segment_id: s.segment_id,
            title: s.name,
            segment: s,
        }));

        return [
            ...segSteps,
            { type: "notes", title: "Notas" },
            { type: "summary", title: "Resumen" },
        ];
    }, [segmentsGroup]);

    const prtsSegCurrent = prtsSegSteps[prtsSegStep];

    const prtsSegOpenModal = () => {
        setPrtsSegStep(0);
        setPrtsSegOpen(true);
        // lock scroll
        const prev = document.body.style.overflow;
        document.body.dataset.prtsPrevOverflow = prev || "";
        document.body.style.overflow = "hidden";
    };

    const prtsSegCloseModal = () => {
        setPrtsSegOpen(false);
        document.body.style.overflow = document.body.dataset.prtsPrevOverflow || "";
        delete document.body.dataset.prtsPrevOverflow;
    };

    const prtsSegNext = () => setPrtsSegStep((p) => clamp(p + 1, 0, prtsSegSteps.length - 1));
    const prtsSegBack = () => setPrtsSegStep((p) => clamp(p - 1, 0, prtsSegSteps.length - 1));

    // resumen (solo visual)
    const prtsSegSummary = useMemo(() => {
        const out = [];
        (segmentsGroup || []).forEach((seg) => {
            if (seg.type === "UNIQ") {
                const selId = selectionState[seg.segment_id];
                const found = seg.items.find((i) => i.item_id === selId);
                if (found) out.push({ segment: seg.name, item: found.name, price: Number(found.price || 0) });
            } else {
                const selIds = selectionState[seg.segment_id] ?? [];
                selIds.forEach((id) => {
                    const found = seg.items.find((i) => i.item_id === id);
                    if (found) out.push({ segment: seg.name, item: found.name, price: Number(found.price || 0) });
                });
            }
        });
        return out;
    }, [segmentsGroup, selectionState]);

    const handleCartQuote = () => {
        if (quoteData) {
            setQuoteData(false);
            setTimeout(() => setQuoteData(true), 100);
        } else {
            setQuoteData(true);
        }
    };

    // Acciones finales (mantienen tu lógica)
    const prtsSegAddToCart = () => {
        formatJsonToAddShoppingCart();
        handleCartQuote();
        prtsSegCloseModal();
    };

    const prtsSegAddToQuote = () => {
        formatJsonToAddShoppingCart(undefined, undefined, undefined, undefined, undefined, true);
        prtsSegCloseModal();
    };

    return (
        <>
            {/* ====== VIEW NORMAL  ====== */}
            <section>
                <div className="gx-4 gx-lg-5 align-items-center z-0">
                    <div className="d-block">
                        <div className="ecomer d-none
                        ">
                            {segmentsGroup.length > 0 ? (
                                <div className="ecomerce pb-3">
                                    {segmentsGroup.map((segment) => (
                                        <div className="m-1" key={`seg-${segment.segment_id}`}>
                                            <h5 className="fw-bold mt-2">{segment.name}</h5>

                                            <div className="container-list-categories d-flex overflow-auto py-1 gap-1 overflow-x ps-1">
                                                {segment?.items?.map((item) => {
                                                    const inputId = `listGroupRadioGrid${segment.segment_id}${item.item_id}`;
                                                    const name = `listGroupRadioGrid${segment.segment_id}`;
                                                    const isChecked =
                                                        segment.type === "UNIQ"
                                                            ? selectionState[segment.segment_id] === item.item_id
                                                            : (selectionState[segment.segment_id] ?? []).includes(item.item_id);

                                                    return (
                                                        <label className="card-segments" htmlFor={inputId} key={inputId}>
                                                            <input
                                                                className="radio-segments"
                                                                type={segment.type === "MULT" ? "checkbox" : "radio"}
                                                                id={inputId}
                                                                name={name}
                                                                checked={isChecked}
                                                                onChange={() => handleChange(segment, item)}
                                                            />

                                                            <span className="plan-details-segments h-100">
                                                                {/* Vista antigua oculta (d-none): sin <img> para no descargar el original.
                                                                    La imagen visible se renderiza en la vista de abajo (optimizada). */}
                                                                <div className="py-1 rounded d-flex justify-content-center" />
                                                                <span className="plan-type-segments text-wrap mb-auto">{item.name} xxx </span>
                                                                <span className="plan-cost-segments text-center">
                                                                    $ {parseFloat(item.price).toFixed(2)}
                                                                </span>
                                                            </span>
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                        {/* Modalidad + cantidad + ordenar
                            (en una columna este bloque se muestra como dock flotante inferior) */}
                        <div className="pdx-actions">

                            {/* Solo tiene sentido dentro de una sesion de mesa (post-pago o pre-pago) -
                                fuera de ahi el pedido entero ya es delivery/pickup/comer aqui elegido en
                                otra pantalla. Por defecto siempre "Comer aqui": nadie tiene que tocar
                                esto para que el pedido salga como siempre salio. */}
                             {hasTableSession ? ( 
                                <div className="pdx-actions__mode">
                                    <span className="pdx-label pdx-actions__label">Modalidad</span>
                                    <div className="pdx-seg" role="group" aria-label="Tipo de pedido">
                                        <button
                                            type="button"
                                            className={`pdx-seg__opt${deliveryType !== "para llevar" ? " active" : ""}`}
                                            aria-pressed={deliveryType !== "para llevar"}
                                            onClick={() => setDeliveryType?.("comer aqui")}
                                        >
                                            <i className="uil uil-utensils" aria-hidden="true" /> Comer aquí
                                        </button>
                                        <button
                                            type="button"
                                            className={`pdx-seg__opt${deliveryType === "para llevar" ? " active" : ""}`}
                                            aria-pressed={deliveryType === "para llevar"}
                                            onClick={() => setDeliveryType?.("para llevar")}
                                        >
                                            <i className="uil uil-shopping-bag" aria-hidden="true" /> Para llevar
                                        </button>
                                    </div>
                                </div>
                             ) : null} 

                            <div className="pdx-actions__qty">
                                <span className="pdx-label pdx-actions__label">Cantidad</span>

                                <div className="pdx-qty" role="group" aria-label="Control de cantidad">
                                    <button type="button" className="pdx-qty__btn" onClick={() => decrement()} aria-label="Disminuir">
                                        <i className="uil uil-minus" aria-hidden="true" />
                                    </button>
                                    <div className="pdx-qty__value" aria-live="polite">
                                        {amount}
                                    </div>
                                    <button type="button" className="pdx-qty__btn" onClick={() => increment()} aria-label="Aumentar">
                                        <i className="uil uil-plus" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>

                            <button type="button" className="pdx-cta pdx-actions__cta" onClick={prtsSegOpenModal} >
                                <span className="pdx-cta__text">
                                    Ordenar <span className="pdx-cta__sep">—</span> ${totalPrice.toFixed(2)}
                                </span>
                                <span className="pdx-cta__icon" aria-hidden="true">
                                    <i className="uil uil-arrow-right" />
                                </span>
                            </button>

                            {/*     <button
                                        type="button"
                                        className="prts-dts-btn-wishlist"
                                        onClick={() => setWishlist((p) => !p)}
                                        aria-pressed={wishlist}
                                        title={wishlist ? "Quitar de favoritos" : "Agregar a favoritos"}
                                    >
                                        {wishlist ? "♥" : "♡"}
                                    </button> */}

                            {/* <button type="button" className="prts-dts-btn-add-cart" onClick={prtsSegOpenModal}>
                                <span aria-hidden="true">🛒</span> Agregar al carrito
                            </button> */}
                        </div>

                        {/* ====== MODAL / OFFCANVAS ====== */}
                        <div className={`prts-seg-modal ${prtsSegOpen ? "open" : ""}`} aria-hidden={!prtsSegOpen}>
                            <button className="prts-seg-backdrop" type="button" onClick={prtsSegCloseModal} aria-label="Cerrar" />

                            <div className="prts-seg-sheet" role="dialog" aria-modal="true" aria-label="Configurar producto">
                                {/* Header */}
                                <div className="prts-seg-header">
                                    <div className="prts-seg-h-title">
                                        {selectedGroup?.name || "Producto"}
                                        <span className="prts-seg-h-sub">Configura tu selección</span>
                                    </div>

                                    <button className="prts-seg-close" type="button" onClick={prtsSegCloseModal} aria-label="Cerrar">
                                        ✕
                                    </button>
                                </div>

                                {/* Stepper */}
                                {/* <div className="prts-seg-stepper">
                  {prtsSegSteps.map((s, idx) => (
                    <React.Fragment key={`${s.type}-${idx}`}>
                      <div className={`prts-seg-step ${idx === prtsSegStep ? "active" : ""}`}>
                        <div className="prts-seg-step-bubble">{idx + 1}</div>
                        <div className="prts-seg-step-label" title={s.title}>
                          {s.title}
                        </div>
                      </div>
                      {idx < prtsSegSteps.length - 1 ? <div className="prts-seg-step-line" /> : null}
                    </React.Fragment>
                  ))}
                </div> */}

                                {/* Body */}
                                <div className="prts-seg-body">
                                    {/* Step: Segment */}
                                    {prtsSegCurrent?.type === "segment" ? (
                                        <div className="prts-seg-panel">
                                            <div className="prts-seg-panel-title">{prtsSegCurrent.title}</div>
                                            <div className="prts-seg-panel-hint">
                                                {prtsSegCurrent.segment.type === "UNIQ" ? "Elige 1 opción" : "Puedes elegir varias"}
                                            </div>

                                            <div className="prts-seg-options">
                                                {(prtsSegCurrent.segment.items || []).map((item) => {
                                                    const segment = prtsSegCurrent.segment;
                                                    const inputId = `listGroupRadioGrid${segment.segment_id}${item.item_id}`;
                                                    const name = `listGroupRadioGrid${segment.segment_id}`;
                                                    const isChecked =
                                                        segment.type === "UNIQ"
                                                            ? selectionState[segment.segment_id] === item.item_id
                                                            : (selectionState[segment.segment_id] ?? []).includes(item.item_id);

                                                    return (
                                                        <label
                                                            key={inputId}
                                                            htmlFor={inputId}
                                                            className={`prts-seg-option ${isChecked ? "selected" : ""}`}
                                                        >
                                                            <input
                                                                className="prts-seg-hidden-input"
                                                                type={segment.type === "MULT" ? "checkbox" : "radio"}
                                                                id={inputId}
                                                                name={name}
                                                                checked={isChecked}
                                                                onChange={() => handleChange(segment, item)}
                                                            />

                                                            <div className="prts-seg-opt-img">
                                                                {/* <img src={item.img} alt={item.name} /> */}


                                                                <img className="logo-img" alt={item.name} loading="lazy"
                                                                    src={buildCloudinaryImageUrl({ url: item.img, width: 300, quality: "auto", type: "image" })}
                                                                    onError={e => e.target.style.opacity = 0}
                                                                />

                                                            </div>

                                                            <div className="prts-seg-opt-text">
                                                                <div className="prts-seg-opt-name">{item.name}</div>
                                                                <div className="prts-seg-opt-price">
                                                                    {Number(item.price || 0) > 0 ? `+ $${Number(item.price).toFixed(2)}` : "Incluido"}
                                                                </div>
                                                            </div>

                                                            <div className="prts-seg-opt-indicator" aria-hidden="true">
                                                                <div className="prts-seg-opt-dot" />
                                                            </div>
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ) : null}

                                    {/* Step: Notes */}
                                    {prtsSegCurrent?.type === "notes" ? (
                                        <div className="prts-seg-panel">
                                            <div className="prts-seg-panel-title">Notas</div>
                                            <div className="prts-seg-panel-hint">Ejemplo: Sin picante, extra salsa, etc.</div>

                                            <textarea
                                                className="prts-seg-notes"
                                                rows={4}
                                                id="text"
                                                name="note"
                                                placeholder="Escribe una nota para la cocina..."
                                                value={note || ""}
                                                onChange={(e) => setNote(e.target.value)}
                                            />
                                        </div>
                                    ) : null}

                                    {/* Step: Summary */}
                                    {prtsSegCurrent?.type === "summary" ? (
                                        <div className="prts-seg-panel">
                                            <div className="prts-seg-panel-title">Resumen</div>
                                            <div className="prts-seg-summary-top">
                                                <div className="prts-seg-summary-prod">
                                                    <div className="prts-seg-summary-name">{selectedGroup?.name}</div>
                                                    <div className="prts-seg-summary-meta">
                                                        Cantidad: <b>{amount}</b> · Base: <b>${Number(priceBase || 0).toFixed(2)}</b>
                                                    </div>
                                                </div>
                                                <div className="prts-seg-summary-total ">Total: ${totalPrice.toFixed(2)}</div>
                                            </div>

                                            <div className="prts-seg-summary-list">
                                                {prtsSegSummary.length ? (
                                                    prtsSegSummary.map((row, idx) => (
                                                        <div className="prts-seg-summary-row" key={idx}>
                                                            <div className="prts-seg-summary-left">
                                                                <div className="prts-seg-summary-seg">{row.segment}</div>
                                                                <div className="prts-seg-summary-item">{row.item}</div>
                                                            </div>
                                                            <div className="prts-seg-summary-right">
                                                                {row.price ? `+ $${Number(row.price).toFixed(2)}` : "Incluido"}
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="prts-seg-summary-empty">Sin selecciones adicionales.</div>
                                                )}
                                            </div>

                                            {note ? (
                                                <div className="prts-seg-summary-notes">
                                                    <div className="prts-seg-summary-notes-label">Notas</div>
                                                    <div className="prts-seg-summary-notes-text">{note}</div>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>

                                {/* Footer (nav + acciones) */}
                                <div className="prts-seg-footer">
                                    <button
                                        type="button"
                                        className="prts-seg-btn-back"
                                        onClick={prtsSegBack}
                                        disabled={prtsSegStep === 0}
                                        aria-disabled={prtsSegStep === 0}
                                    >
                                        ← Atrás
                                    </button>

                                    <div className="prts-seg-footer-right">
                                        {prtsSegCurrent?.type === "summary" ? (
                                            <>
                                                {quoteMode === true ? (
                                                    <button type="button" className="prts-seg-btn-outline" onClick={prtsSegAddToQuote}>
                                                        Agregar a cotización
                                                    </button>
                                                ) : null}

                                                <button type="button" className="prts-seg-btn-primary" onClick={prtsSegAddToCart}>
                                                    <i class="uil uil-shopping-cart"></i>   Ordenar · ${totalPrice.toFixed(2)}
                                                </button>
                                            </>
                                        ) : (
                                            <button type="button" className="prts-seg-btn-primary" onClick={prtsSegNext}>
                                                Siguiente →
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ====== /MODAL ====== */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Segments;